import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {toast} from "react-hot-toast";
import { apiEndPoints } from "../../ApiServices/config";
import { postApi } from "../../ApiServices/api";
import moment from "moment";
function useLoadCheckAvailability() {
    const devoteeData = JSON.parse(localStorage.getItem("devoteeData"));
    const rentCartArr = useSelector((state) => state.rentArr);
    const navigate = useNavigate();
    
    const handleCheckAvailability = async () => {
        const data = {
          id: devoteeData?.user_id,
          items: rentCartArr.map((item) => ({
            name: item.title,
            date: moment(item?.data?.selectedDate).format("YYYY/MM/DD"),
            additional_options: item?.data?.additional_options,
            duration: item.duration,
            additional_hour: item.duration - item?.rawData?.amount_hour,
            number_of_attendees: item?.number_of_attendees,
            booking_option: item?.rawData?.booking_option,
            additional_hour_amount:
              item?.rawData?.additional_hour_amount *
              (item?.duration - item?.rawData?.amount_hour),
            start_time: moment(item?.data?.start_time).format("h:mm A"),
            end_time: moment(item?.data?.end_time).format("h:mm A"),
            totalCost: item.total,
            type: "rental",
          })),
          total: rentCartArr?.reduce((total, item) => total + item.total, 0),
        };
    
        try {
          const response = await postApi(apiEndPoints.checkAvailability, data);
          if (response?.data?.status === 0) {
            toast.error(response?.data?.message);
          } else if (response?.data?.status === 1) {
            navigate("/checkavailabilitysent");
          } else {
            toast.error("Something Went Wrong");
          }
        } catch (error) {
          toast.error(`Something Went Wrong: , ${error}`);
        }
    };

    return {
        handleCheckAvailability,
        navigate,
        devoteeData,
        rentCartArr,
    };

}
export default useLoadCheckAvailability;